/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';

export class Locale extends Model {
  id: number;
  active: boolean;
  name: string;
  locale: string;

  get formattedName(): String {
    return this.name + '(' + this.locale + ')';
  }
}
